<template>
	<app-page>
		<app-heading :title="externalId ? `Transactions - ${externalId} (${booking.unit_code})` : `Transactions - booking.unit_code`" />
		<app-row>
			<app-cell>
				<app-data-table
					:items="payment.transactions"
					:headers="headers"
					:sort-by="'ts'"
					:sort-desc="true"
					:dynamic="false"
				>
					<template v-slot:status="{ item }">
						<span v-if="item.status === 0" class="warning--text">Pending</span>
						<span v-if="item.status === 1" class="success--text">Success</span>
						<span v-if="item.status === 2" class="error--text">Error</span>
						<span v-if="item.status === 3" class="primary--text">In Progress</span>
					</template>
					<template v-slot:error="{ item }">
							<span
								v-if="item.error"
							>
								<app-tooltip :text="item.error">
									{{ item.error.substr(0, 50) }}
									<span v-if="item.error.length > 50">...</span>
								</app-tooltip>
							</span>
							<span v-else>N/A</span>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
	</app-page>
</template>

<script>
export default {
	async created() {
		try {
			this.payment = await this.$ravello.request()
				.v(2)
				.to('bookingpayments')
				.to(this.id)
				.get()
			this.booking = await this.$ravello.request()
				.v(2)
				.to('bookings')
				.to(this.payment.booking)
				.get()
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
	},
	data() {
		return {
			payment: {
				transactions: [],
			},
			booking: {
				content: {
					id: null,
				},
			},
			headers: [{
				text: 'Status',
				value: 'status',
				sortable: true,
			}, {
				text: 'Confirmed At',
				value: 'ts',
				sortable: true,
				format: 'datetime',
			}, {
				text: 'Amount',
				value: 'amount',
				sortable: false,
				format: 'currency',
			}, {
				text: 'Error',
				value: 'error',
				sortable: false,
			}],
		}
	},
	computed: {
		id() {
			return this.$route.params.booking_payment
		},
		externalId() {
			return this.booking.content && this.booking.content.id
		},
	},
}
</script>
